(function() {
  var UTM_PARAMS = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid','ttclid'];
  var COOKIE_NAME = 'madesa_utms';
  var COOKIE_DOMAIN = '.madesa.com';
  var COOKIE_MINUTES = 1440;

  function getUtmsFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var utms = {};
    var found = false;
    UTM_PARAMS.forEach(function(p) {
      if (params.has(p)) { utms[p] = params.get(p); found = true; }
    });
    return found ? utms : null;
  }

  function getUtmsFromCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return null;
    try { return JSON.parse(decodeURIComponent(match[1])); } catch(e) { return null; }
  }

  function saveUtmsCookie(utms) {
    var expires = new Date(Date.now() + COOKIE_MINUTES * 60 * 1000).toUTCString();
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(utms)) +
      '; expires=' + expires + '; path=/; domain=' + COOKIE_DOMAIN + '; SameSite=Lax; Secure';
  }

  function injectUtms(href, utms) {
    try {
      var url = new URL(href);
      Object.keys(utms).forEach(function(k) {
        if (!url.searchParams.has(k)) url.searchParams.set(k, utms[k]);
      });
      return url.toString();
    } catch(e) { return href; }
  }

  function interceptLinks(utms) {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
  
      var isSubdomain = /^https?:\/\/(?!www\.)[a-z0-9-]+\.madesa\.com/i.test(link.href);
      if (!isSubdomain) return;
  
      link.href = injectUtms(link.href, utms);
    }, true);
  }

  var utms = getUtmsFromUrl() || getUtmsFromCookie();
  if (utms) {
    saveUtmsCookie(utms);
    interceptLinks(utms);
  }
})();
